/** @jsx h */
import { h } from 'preact'

const ThumbsUpIcon = () => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='24'
      height='24'
      fill='none'
      viewBox='0 0 24 24'
      aria-label='Yes'
    >
      <path
        stroke='currentColor'
        fill='white'
        d='M5.5 20.0475C6.37117 20.6549 7.41971 20.9878 8.49918 21H17.7467C18.7107 21.0031 19.4949 20.2612 19.4983 19.3428C19.5 18.8811 19.3 18.4394 18.9463 18.1237C19.9009 18.0254 20.5912 17.2085 20.488 16.2992C20.4432 15.9042 20.2509 15.5377 19.9461 15.2666C20.9008 15.1694 21.5921 14.3533 21.49 13.4438C21.4274 12.8854 21.0719 12.3952 20.5459 12.1418C21.484 11.5868 21.7722 10.4125 21.1896 9.5188C20.8258 8.96077 20.1858 8.62068 19.4962 8.61899H12.4981C12.7727 7.78567 13.0226 5.68139 13.1364 4.21426C13.1386 3.02379 11.8732 1 10.9985 1C10.459 1.0075 9.93518 1.17384 9.4989 1.4762C9.74206 3.30158 9.74206 4.41268 9.4989 4.80952C9.13415 5.40477 6.77215 10.6428 6.49971 10.9999C6.31809 11.238 5.98485 11.3968 5.5 11.4761V20.0475Z'
      />
    </svg>
  )
}

export default ThumbsUpIcon
